export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20golden%20and%20deep%20red%20light%20streaks%2C%20luxurious%20theater%20atmosphere%2C%20soft%20bokeh%20texture%2C%20elegant%20velvet%20curtain%20vibe%2C%20dramatic%20lighting%2C%20no%20text%2C%20no%20people%2C%20abstract%20art%20style%2C%20rich%20contrast%2C%20cinematic%20mood&width=1920&height=1080&seq=hero-bg-movie-01&orientation=landscape"
          alt="八戒电影网背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-background-50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-400 text-xs md:text-sm font-medium tracking-wide border border-primary-500/30 whitespace-nowrap">
              不缓冲 · 无广告 · 流畅播放
            </span>

            <h1 className="mt-4 md:mt-5 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 leading-tight">
              八戒电影网
              <br />
              <span className="text-primary-400">高清在线观影首选平台</span>
            </h1>

            <p className="mt-5 md:mt-6 text-foreground-400 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              八戒电影网采用高速服务器集群部署，确保每部影片不缓冲流畅播放。全站无广告干扰，打开即看，告别卡顿等待。
              海量高清影视资源每日更新，涵盖院线大片、热门剧集、经典老片、动漫综艺等全方位内容，
              致力于为影迷打造极致观影体验。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-foreground-300 text-xs md:text-sm">
                <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                <span>片库已更新 <strong className="text-foreground-100">12,000+</strong> 部</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-300 text-xs md:text-sm">
                <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                <span>今日上新 <strong className="text-foreground-100">86</strong> 部影片</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-300 text-xs md:text-sm">
                <div className="w-2 h-2 rounded-full bg-secondary-500"></div>
                <span>高清画质 <strong className="text-foreground-100">1080P+</strong> 全覆盖</span>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#index"
                className="w-full sm:w-auto px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold text-sm rounded-lg transition-colors cursor-pointer text-center whitespace-nowrap"
              >
                <i className="ri-play-circle-line mr-2"></i>开始观影
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-7 py-3 bg-background-100 hover:bg-background-200 text-foreground-200 font-medium text-sm rounded-lg transition-colors cursor-pointer text-center whitespace-nowrap border border-background-300/50"
              >
                <i className="ri-fire-line mr-2"></i>查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px]">
              <div className="relative rounded-xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stunning%20cinematic%20film%20poster%20composition%20featuring%20dramatic%20warm%20golden%20light%20beams%20piercing%20through%20darkness%2C%20elegant%20movie%20reel%20and%20film%20strip%20elements%20subtly%20integrated%2C%20luxurious%20theater%20atmosphere%2C%20rich%20amber%20and%20deep%20crimson%20tones%2C%20abstract%20cinematic%20art%2C%20no%20text%2C%20high%20contrast%20dramatic%20lighting&width=960&height=720&seq=hero-movie-poster-02&orientation=portrait"
                  alt="八戒电影网 高清电影在线观看"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
              </div>
              <div className="absolute -bottom-3 -right-3 w-20 h-20 md:w-24 md:h-24 bg-primary-500/20 rounded-xl border border-primary-500/30 flex flex-col items-center justify-center backdrop-blur-sm">
                <span className="font-heading text-xl md:text-2xl font-bold text-primary-400">4K</span>
                <span className="text-[10px] md:text-xs text-foreground-300">超清画质</span>
              </div>
              <div className="absolute -top-3 -left-3 w-16 h-16 md:w-20 md:h-20 bg-accent-500/20 rounded-xl border border-accent-500/30 flex flex-col items-center justify-center backdrop-blur-sm">
                <span className="font-heading text-lg md:text-xl font-bold text-accent-400">0</span>
                <span className="text-[10px] md:text-xs text-foreground-300">广告</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}